import { createApi } from '@reduxjs/toolkit/query/react'

import { customBaseQuery } from './CustomBaseQuery'

export const mainSplitApi = createApi({
  reducerPath: 'mainSplitApi',
  tagTypes: ['Workflow', 'Instance', 'InstanceProfiles', 'InstanceCategories', 'Execution'],
  baseQuery: customBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL
  }),
  endpoints: (builder) => ({})
})
